module.exports = __webpack_public_path__ + "static/media/Picker_specifiques_elN311_1141790305.9bced0a7.png";